import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async getDisease(diseaseId: number) {
    return wrapEndpoint(() => client.GET('/kira/disease/{diseaseId}', { params: { path: { diseaseId } } }))
  },
}
